import { reactive } from 'vue'
import safeAreaInsets from 'safe-area-insets'

// The lib's getters measure env(safe-area-inset-*) on every read but are not
// reactive. WKWebView reports 0 until its first paint after a load, and the
// values change on rotation, so a computed that read them too early kept the
// notch bar hidden. Mirror them into a reactive object kept current by the lib.
const safeArea = reactive({ top: 0, right: 0, bottom: 0, left: 0 })
const read = () => Object.assign(safeArea, {
  top: safeAreaInsets.top,
  right: safeAreaInsets.right,
  bottom: safeAreaInsets.bottom,
  left: safeAreaInsets.left,
})

// Setup function for Vue 3
export const setupSafeAreaInsets = app => {
  app.config.globalProperties.$safeArea = safeArea
  read()
  safeAreaInsets.onChange(read)
}

// Export the reactive insets directly for use in Composition API
export default safeArea
